// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dialog from "../Dialog/Dialog.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import DialogCyclingModuleCss from "./DialogCycling.module.css";

let classes = DialogCyclingModuleCss;

function DialogCycling(props) {
  let onPrevious = props.onPrevious;
  let onNext = props.onNext;
  let onDismiss = props.onDismiss;
  return <Dialog.make
    className={classes.root + ` ` + Stdlib_Option.getOr(props.className, "")}
    visible={props.visible}
  >
    <header>
      <button
        className={Styles.button.iconOnly + ` ` + classes.closeButton}
        title={"Zavřít dialog"}
        onClick={param => onDismiss()}
      >
        {"✖️"}
      </button>
      <div
        className={classes.heading}
      >
        <h3>
          {props.header}
        </h3>
        {Stdlib_Option.getOr(props.headerSlot, null)}
      </div>
    </header>
    <Dialog.DialogBody.make>
      {props.children}
    </Dialog.DialogBody.make>
    <footer>
      <button
        className={Styles.button.base}
        disabled={!props.hasPrevious}
        type={"button"}
        onClick={param => onPrevious()}
      >
        {"⬅️ Předchozí"}
      </button>
      <button
        className={Styles.button.base}
        disabled={!props.hasNext}
        type={"button"}
        onClick={param => onNext()}
      >
        {"Následující ➡️"}
      </button>
    </footer>
  </Dialog.make>;
}

let make = DialogCycling;

export {
  classes,
  make,
}
/* classes Not a pure module */
